import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/wishlist/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  SubtituloSeccion,
  Seccion,
  Footer,
  Loader,
  HeadTags,
  BtnFlotanteWhatsapp,
  ItemProductoV2,
  CarouselDeBanners,
}from '../../components';

import {
  Button,
  useTheme,
} from '@mui/material';


const WishlistPage = (props)=>{
    
  const theme = useTheme();

  const {
    mobile,
    loadingProductos,
    productos,
  } = useHook();
    
  return(<>

    <HeadTags
      title="Wishlist"
      description=""
      path={props.pageProps.pathname}
      noIndex={true}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Wishlist</TituloSeccion>
        <br/>
        <SubtituloSeccion align="center">Productos que te enamoraron</SubtituloSeccion>
        <br/><br/>
        <div className={styles.contenedor}>

          {loadingProductos ?
            <Loader
              spinner={true}
              skeleton={false}
              variant="rectangular" 
              width={!mobile ? 1400 : 480}
              height={!mobile ? 300 : 400}   
              color="secondary"
              opacity="1"
            />
            :
            productos?.length > 0 ? <>
              {productos?.map(item=>(
                <ItemProductoV2 data={item} key={item.id}/>
              ))}
            </>
              : <p align="center">Sin productos en tu wishlist.</p>
          }                      
                    

        </div>
      </Wrapper>
    </Seccion>

    <br/><br/><br/>
        
    <Footer/>
 
    <BtnFlotanteWhatsapp/>
  </>);
};

export default WishlistPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    return {
      props: {
        pathname: getCanonicalPath(req),
      },
    };    
  
  },
);